import { BaseResults } from 'libs/searchspring/components/recommendations/BaseResults'

export function GridResults({
  className,
  wrapperClassName = '',
  productCardSettings
}) {
  return (
    <BaseResults
      className={className}
      wrapperClassName={`${wrapperClassName} gap-[--grid-gap-mb] md:gap-[--grid-gap] flex-wrap`}
      productCardSettings={productCardSettings}
    />
  )
}
